<template>
  <div class="testrecord_body">
    <div style="padding: 40px">
      <!-- <div style="width: 30%; display: flex; margin-left: 20px">
        <el-input v-model="value" style="width: 50%" placeholder="请输入学号">
        </el-input>
        <el-button @click="searchsy">搜索</el-button>
      </div> -->
      <el-table
        :data="
          sydata.slice((currentPage - 1) * pagesize, currentPage * pagesize)
        "
        stripe
        ref="multipleTable"
        tooltip-effect="dark"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column type="index" align="center" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="createBy" align="center" label="学号">
        </el-table-column>
        <el-table-column prop="createUserName" align="center" label="姓名">
        </el-table-column>
        <el-table-column prop="score" label="分数" align="center">
        </el-table-column>
        <el-table-column prop="createTime" label="提交时间" align="center">
          <template slot-scope="scope">
            <span>{{
              dayjs(scope.row.createTime).format("YYYY-MM-DD HH:mm:ss")
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page" style="margin-top: 30px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 40]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="sydata.length"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testrecord",
  data() {
    return {
      currentIndex: "",
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      sydata: [],
      value: "",
    };
  },
  methods: {
    handleSizeChange: function (size) {
      this.pagesize = size;
      // console.log(this.pagesize) //每页下拉显示数据
    },
    handleCurrentChange: function (currentPage) {
      console.log(currentPage);
      this.currentPage = currentPage;
      this.getSoftwareScore();
      // console.log(this.currentPage) //点击第几页
    },
    // 实验题搜索
    searchsy() {
      console.log(this.value);
      let url = "/score/list/0?createBy=" + this.value ;
      this.$axios.get(url).then((resp) => {
        if (resp.data.success) {
          this.sydata = resp.data.result.content;
        } else {
          this.$message.error("操作失败");
        }
      });
    },
    getSoftwareScore() {
      let url = "/score/list/" + (this.currentPage - 1);

      this.$axios.get(url).then((resp) => {
        var content = resp.data.result.content;
        if ((content.type = "null")) {
          this.sydata = resp.data.result.content;
        }
        this.total = resp.data.result.totalElements;
      });
    },
  },
  mounted() {
    this.value = localStorage.getItem("username");
    this.searchsy();
    // this.getSoftwareScore()
  },
};
</script>

<style scoped>
.testrecord_body {
  background: url("../../assets/banner/login.png");
  min-height: 790px;
}
</style>
